import { ref } from 'vue'

export interface ConfirmOptions {
  title: string
  description?: string
  confirmLabel?: string
  cancelLabel?: string
  variant?: 'default' | 'destructive'
}

const isOpen = ref(false)
const options = ref<ConfirmOptions>({ title: '' })
let resolvePromise: ((value: boolean) => void) | null = null

export function confirm(opts: ConfirmOptions): Promise<boolean> {
  options.value = opts
  isOpen.value = true

  return new Promise<boolean>((resolve) => {
    resolvePromise = resolve
  })
}

/** Internal — used only by ConfirmDialog.vue. */
export function useConfirmDialogState() {
  function settle(result: boolean): void {
    isOpen.value = false
    resolvePromise?.(result)
    resolvePromise = null
  }

  return { isOpen, options, settle }
}
